import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams } from '../useServerParams';

export const fileModuleTypes = {
    document: {
        cashSales: {
            value: "cash_sales",
        },
        salesOrder: {
            value: "sales",
        },
        salesInvoice: {
            value: "sales_invoice",
        },
        deliveryOrder: {
            value: "delivery",
        },
        itemReceive: {
            value: "item_receive",
        },
    },
    item: {
        product: {
            value: "product",
        },
        item: {
            value: "item",
        }
    },
    repository: {
        package: {
            value: "package",
        },
        container: {
            value: "container",
        }
    },
    user: {
        administrator: {
            value: "administrator",
        },
        supplier: {
            value: "supplier",
        },
        retailer: {
            value: "retailer",
        },
        customer: {
            value: "customer",
        },
        driver: {
            value: "driver",
        },
        worker: {
            value: "worker",
        },
    }
}

export const fileReferenceTypes = {
    document: {
        cashSales: {
            value: "document",
        },
        salesOrder: {
            value: "document",
        },
        salesInvoice: {
            value: "document",
        },
        deliveryOrder: {
            value: "document",
        },
        itemReceive: {
            value: "document",
        },
    },
    documentItem: {
        cashSales: {
            value: "document_item",
        },
        salesOrder: {
            value: "document_item",
        },
        salesInvoice: {
            value: "document_item",
        },
        deliveryOrder: {
            value: "document_item",
        },
        itemReceive: {
            value: "document_item",
        },
    },
    item: {
        product: {
            value: "item",
        },
        item: {
            value: "item",
        }
    },
    repository: {
        package: {
            value: "repository",
        },
        container: {
            value: "repository",
        }
    },
    repositoryItem: {
        package: {
            value: "repository_item",
        },
        container: {
            value: "repository_item",
        }
    },
    user: {
        administrator: {
            value: "administrator",
        },
        supplier: {
            value: "supplier",
        },
        retailer: {
            value: "retailer",
        },
        customer: {
            value: "customer",
        },
        driver: {
            value: "driver",
        },
        worker: {
            value: "worker",
        },
    }
}

export const targetTypes = {
    file: "file"
}

export function useFiles({
    targetType: _targetType = ""
}) {

    // const [fileModule, setFileModule] = useState(_fileModule);
    const [targetType, setTargetType] = useState(_targetType);
    // const [fileReference, setFileReference] = useState(_fileReference);

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint1 = "file";
    const endpoint2 = "files"

    const list = async (props) => {

        setIsLoading(true);

        try {

            let url = getListsUrl(`${endpoint2}/${targetType}`, props);

            // if (targetType) {
            //     url = getListsUrl(`${endpoint2}/${groupType}/${targetType}`, props);
            // }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const create = async ({ data, targetType: overrideTargetType }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint1}`;

            let postData = {
                scope: {
                    target: targetType,
                    action: "",
                },
                payload: data
            }

            if (overrideTargetType) postData.scope.target = overrideTargetType

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const remove = async ({ ids }) => {

        setIsLoading(true);

        if (ids.length <= 0) {
            throw getError(false, `Please select at least (1) items`)
        }

        try {

            let url = `${endpoint2}/delete`

            const postData = {
                scope: {
                    target: targetType
                },
                payload: {
                    ids
                }
            }

            const response = await makeCall({
                url,
                method: "POST",
                payload: postData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    const get = async ({ id, targetType: overrideTargetType, dataTypesArray = [] }) => {

        setIsLoading(true);

        try {

            let url = getUrlWithDataTypes(`${endpoint1}/${targetType}/${id}`, dataTypesArray)

            if (overrideTargetType) {
                url = getUrlWithDataTypes(`${endpoint1}/${overrideTargetType}/${id}`, dataTypesArray)
            }

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        targetTypes,
        list,
        get,
        create,
        // update,
        remove
    }
}